import type { ThemeConfig } from "antd";

// import darkTokens from '#src/assets/tokens/Dark.tokens.json';
// import lightTokens from '#src/assets/tokens/Light.tokens.json';
// import mode1Tokens from '#src/assets/tokens/Mode 1.tokens.json';

/**
 * Helper to safely extract hex values from Figma tokens
 * Supports both flat and nested token structures
 */
// function getHex(tokens: any, category: string, name: string, fallback: string): string {
// 	// Try flat structure first (Light/Dark tokens)
// 	if (tokens[category]?.[name]?.$value) {
// 		const val = tokens[category][name].$value;
// 		if (typeof val === 'object' && val?.hex)
// return val.hex;
// 		if (typeof val === 'string')
// return val;
// 	}
//
// 	return fallback;
// }

/**
 * Special helper for Mode 1 color tokens that have deep nesting
 */
// function getMode1Color(tokens: any, path: string, fallback: string): string {
// 	const parts = path.split('.');
// 	let current = tokens;
//
// 	for (const part of parts) {
// 		if (current[part]) {
// 			current = current[part];
// 		} else {
// 			return fallback;
// 		}
// 	}
//
// 	// Handle $value object or string
// 	if (current?.$value) {
// 		const val = current.$value;
// 		if (typeof val === 'object' && val?.hex)
// return val.hex;
// 		if (typeof val === 'string')
// return val;
// 	}
//
// 	return fallback;
// }

/**
 * Special helper for Mode 1 number tokens (border radius, sizes, etc.)
 */
// function getMode1Number(tokens: any, path: string, fallback: number): number {
// 	const parts = path.split('.');
// 	let current = tokens;
//
// 	for (const part of parts) {
// 		if (current[part]) {
// 			current = current[part];
// 		} else {
// 			return fallback;
// 		}
// 	}
//
// 	// Handle $value
// 	if (current?.$value !== undefined) {
// 		const val = current.$value;
// 		if (typeof val === 'number')
// return val;
// 		if (typeof val === 'string') {
// 			const parsed = Number.parseFloat(val);
// 			return Number.isNaN(parsed) ? fallback : parsed;
// 		}
// 	}
//
// 	return fallback;
// }

/**
 * Extract Mode 1 theme configuration
 */
// export function getMode1Theme(): ThemeConfig {
// 	return {
// 		token: {
// 			// Primary colors from Mode 1
// 			colorPrimary: getMode1Color(mode1Tokens, 'Color.Primary.colorPrimary', '#424AF9'),
// 			// colorPrimaryBg: getMode1Color(mode1Tokens, 'Color.Primary.colorPrimaryBG', '#DCE9FF'),
// 			colorPrimaryHover: getMode1Color(mode1Tokens, 'Color.Primary.colorPrimaryHover', '#5266FF'),
// 			colorPrimaryActive: getMode1Color(mode1Tokens, 'Color.Primary.colorPrimaryActive', '#262ADC'),
// 			colorPrimaryText: getMode1Color(mode1Tokens, 'Color.Primary.colorPrimaryText', '#424AF9'),
//
// 			// Success colors
// 			colorSuccess: getMode1Color(mode1Tokens, 'Color.Success.colorSuccess', '#52C41A'),
// 			colorSuccessBg: getMode1Color(mode1Tokens, 'Color.Success.colorSuccessBG', '#F6FFED'),
// 			colorSuccessHover: getMode1Color(mode1Tokens, 'Color.Success.colorSuccessHover', '#73D13D'),
//
// 			// Error colors
// 			colorError: getMode1Color(mode1Tokens, 'Color.Error.colorError', '#F5222D'),
// 			colorErrorBg: getMode1Color(mode1Tokens, 'Color.Error.colorErrorBG', '#FFF1F0'),
// 			colorErrorHover: getMode1Color(mode1Tokens, 'Color.Error.colorErrorHover', '#FF4D4F'),
//
// 			// Warning colors
// 			colorWarning: getMode1Color(mode1Tokens, 'Color.Warning.colorWarning', '#FAAD14'),
// 			colorWarningBg: getMode1Color(mode1Tokens, 'Color.Warning.colorWarningBG', '#FFFBE6'),
// 			colorWarningHover: getMode1Color(mode1Tokens, 'Color.Warning.colorWarningHover', '#FFC53D'),
//
// 			// Info colors (uses Primary colors in Mode 1)
// 			colorInfo: getMode1Color(mode1Tokens, 'Color.Info.colorInfo', '#424AF9'),
// 			colorInfoBg: getMode1Color(mode1Tokens, 'Color.Info.colorInfoBG', '#DCE9FF'),
// 			colorInfoHover: getMode1Color(mode1Tokens, 'Color.Info.colorInfoHover', '#5266FF'),
//
// 			// Link colors
// 			colorLink: getMode1Color(mode1Tokens, 'Color.Primary.colorPrimaryTextHover', '#5266FF'),
// 			colorLinkHover: getMode1Color(mode1Tokens, 'Color.Primary.colorLinkHover', '#5266FF'),
// 			colorLinkActive: getMode1Color(mode1Tokens, 'Color.Primary.colorLinkActive', '#262ADC'),
//
// 			// Neutral colors from Mode 1
// 			// colorBgBase: getMode1Color(mode1Tokens, 'Color.Neutral.Background.colorBgLayout', '#F7F8F8'),
// 			// colorBgContainer: getMode1Color(mode1Tokens, 'Color.Neutral.Background.colorBgContainer', '#FFFFFF'),
// 			// colorBgElevated: getMode1Color(mode1Tokens, 'Color.Neutral.Background.colorBgElevated', '#FFFFFF'),
// 			// colorBgLayout: getMode1Color(mode1Tokens, 'Color.Neutral.Background.colorBgLayout', '#F7F8F8'),
//
// 			// Text colors
// 			// colorTextBase: getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorText', '#000000'),
// 			// colorText: getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorText', '#000000'),
// 			// colorTextSecondary: getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorTextLabel', '#000000'),
// 			// colorTextDescription: getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorTextDescription', '#000000'),
// 			// colorTextPlaceholder: getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorTextPlaceholder', '#000000'),
// 			// colorTextDisabled: getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorTextDisabled', '#000000'),
//
// 			// Border colors
// 			// colorBorder: getMode1Color(mode1Tokens, 'Color.Neutral.Borders.colorBorder', '#D8DBDF'),
// 			// colorBorderSecondary: getMode1Color(mode1Tokens, 'Color.Neutral.Borders.colorBorderSecondary', '#EDEEF1'),
// 			// colorSplit: getMode1Color(mode1Tokens, 'Color.Neutral.Borders.colorSplit', '#000000'),
//
// 			// Fill colors
// 			// colorFill: getMode1Color(mode1Tokens, 'Color.Neutral.Fill.colorFill', '#000000'),
// 			// colorFillSecondary: getMode1Color(mode1Tokens, 'Color.Neutral.Fill.colorFillSecondary', '#000000'),
// 			// colorFillTertiary: getMode1Color(mode1Tokens, 'Color.Neutral.Fill.colorFillTertiary', '#000000'),
//
// 			// Border radius from Style section - using getMode1Number for numbers
// 			borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 			// borderRadiusLG: getMode1Number(mode1Tokens, 'Style.borderRadiusLG', 1),
// 			borderRadiusSM: getMode1Number(mode1Tokens, 'Style.borderRadiusSM', 12),
// 			// borderRadiusXS: getMode1Number(mode1Tokens, 'Style.borderRadiusXS', 8),
//
// 			wireframe: false,
// 		},
// 		components: {
// 			Button: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 				borderColorDisabled: "rgb(255,40,40)",
// 			},
// 			Input: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 			},
// 			InputNumber: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 			},
// 			Mentions: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 			},
// 			Select: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 			},
// 			Segmented: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 				trackPadding: 4,
// 			},
// 			Tabs: {
// 				cardPadding: "4px 16px",
// 			},
// 			Tag: {
// 				borderRadiusSM: 999,
// 				paddingXS: 10,
// 				paddingXXS: 6,
// 			},
// 			Tooltip: {
// 				borderRadius: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 			},
// 			Menu: {
// 				itemBorderRadius: getMode1Number(mode1Tokens, 'Style.borderRadiusXS', 8),
// 				subMenuItemBorderRadius: getMode1Number(mode1Tokens, 'Style.borderRadiusXS', 8),
// 			},
// 			Card: {
// 				borderRadiusLG: getMode1Number(mode1Tokens, 'Style.borderRadius', 16),
// 				borderRadiusSM: getMode1Number(mode1Tokens, 'Style.borderRadiusSM', 12),
// 			},
// 		},
// 	};
// }

/**
 * Export Mode 1 theme separately
 */
// export const customAntdMode1Theme = getMode1Theme();

/**
 * Custom tokens that are not part of Ant Design standard AliasToken
 * We will export this to be injected into CSS separately
 */
// export function customExtraTokens(isDark: boolean) {
	// const mode1SolidText = getMode1Color(mode1Tokens, 'Color.Neutral.Text.colorTextSolid', '#FFFFFF');

	// return {
		// colorTextSolid: mode1SolidText,
		// colorTextSolidDark: isDark ? '#25272C' : '#25272C',
	// };
// }

/**
 * Custom Ant Design light theme configuration merged with Figma Tokens
 */
export const customAntdLightTheme: ThemeConfig = {
	// token: {
	// 	...customAntdMode1Theme.token,
	// 	colorPrimary: getHex(lightTokens, 'Primary', 'primary-6', "#424AF9"),
	// 	// colorPrimaryBg: getHex(lightTokens, 'Primary', 'primary-1', "#DCE9FF"),
	// 	colorInfo: getHex(lightTokens, 'Info', 'info-6', "#5b9cf0"),
	// 	colorSuccess: getHex(lightTokens, 'Success', 'success-6', "#1bab9a"),
	// 	colorError: getHex(lightTokens, 'Error', 'error-6', "#e11d48"),
	// 	colorWarning: getHex(lightTokens, 'Warning', 'warning-6', "#fb923c"),
	// 	colorLink: getHex(lightTokens, 'Primary', 'primary-5', "#52a5c1"),
	//
	// 	// Neutral & Background Mapping
	// 	// colorBgBase: getHex(lightTokens, 'Neutral', 'bg-layout', "#f3f3f3"),
	// 	colorTextBase: getHex(lightTokens, 'Neutral', 'text', "#000000"),
	// 	colorBorder: getHex(lightTokens, 'Neutral', 'border', "#d9d9d9"),
	//
	// 	borderRadius: 16,
	// 	wireframe: false,
	// },
	// components: {
	// 	Button: {
	// 		borderColorDisabled: "rgb(255,40,40)",
	// 	},
	// 	Input: { borderRadius: 16 },
	// 	InputNumber: { borderRadius: 16 },
	// 	Mentions: { borderRadius: 16 },
	// 	Select: { borderRadius: 16 },
	// 	Segmented: { borderRadius: 16, trackPadding: 4 },
	// 	Tabs: { cardPadding: "4px 16px" },
	// 	Tag: { borderRadiusSM: 999, paddingXS: 10, paddingXXS: 6 },
	// 	Tooltip: { borderRadius: 16 },
	// },
};

/**
 * Custom Ant Design dark theme configuration merged with Figma Tokens
 */
export const customAntdDarkTheme: ThemeConfig = {
	// token: {
	// 	// ...customAntdLightTheme.token,
	// 	colorPrimary: getHex(darkTokens, 'Primary', 'primary-6', "#7baaf7"),
	// 	colorInfo: getHex(darkTokens, 'Info', 'info-6', "#7baaf7"),
	// 	colorSuccess: getHex(darkTokens, 'Success', 'success-6', "#2bc4b6"),
	// 	colorError: getHex(darkTokens, 'Error', 'error-6', "#f85149"),
	// 	colorWarning: getHex(darkTokens, 'Warning', 'warning-6', "#ffa940"),
	// 	colorLink: getHex(darkTokens, 'Primary', 'primary-5', "#6bb9d6"),
	//
	// 	// Neutral & Background Mapping
	// 	colorBgBase: getHex(darkTokens, 'Neutral', 'bg-layout', "#000000"),
	// 	colorTextBase: getHex(darkTokens, 'Neutral', 'text', "#ffffff"),
	// 	colorBorder: getHex(darkTokens, 'Neutral', 'border', "#424242"),
	// 	borderRadius: 16,
	// 	// borderRadiusLG: getMode1Number(mode1Tokens, 'Style.borderRadiusLG', 1),
	// 	borderRadiusSM: getMode1Number(mode1Tokens, 'Style.borderRadiusSM', 12),
	// 	// borderRadiusXS: getMode1Number(mode1Tokens, 'Style.borderRadiusXS', 8),
	// },
	// components: {
	// 	...customAntdLightTheme.components,
	// 	Menu: {
	// 		darkItemBg: getHex(darkTokens, 'Neutral', 'bg-container', "#141414"),
	// 	},
	// },
};
